/*global wombatAjax*/

/*
 * General custom scripts
 **/
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

/**
 * MegaMenu data
 */
const megamenu = document.querySelector( '.megamenu' );

/**
 * MegaMenu data
 *
 * @return {mixed} megamenu height or false
 */
const megamenuHeight = () => {

	if ( megamenu ) {

		return window.innerHeight - Math.ceil( megamenu.getBoundingClientRect().top );

	}
	return false;

}

/**
 * Nav trigger
 */
const navTrigger = document.querySelector( '.js-nav-trigger' );
navTrigger.addEventListener( 'click', () => {

	const body = document.querySelector( 'body' );

	body.classList.toggle( 'js-nav-open' );
	body.classList.remove( 'js-search-open' );

	if ( megamenu ) {

		if ( body.classList.contains( 'js-nav-open' ) ) {

			megamenu.style.maxHeight = `${ megamenuHeight() }px`;
			megamenu.scrollTop = 0;

		} else {

			megamenu.style.maxHeight = '';

		}

	}

} );

/**
 * Mobile nav levels
 */
const navParentItems = document.querySelectorAll( '.megamenu__nav > li' );

navParentItems.forEach( ( navParentItem ) => {

	navParentItem.addEventListener( 'click', ( e ) => {

		if (
			! navParentItem.classList.contains( 'js-active' ) &&
			window.innerWidth <= 1140
		) {

			e.preventDefault();

			const navParentLink = navParentItem.querySelector( ':scope > a' );
			const navParentSubmenu = navParentItem.querySelector(
				':scope > ul'
			);
			const newItem = document.createElement( 'li' );
			const newLink = navParentLink.cloneNode( true );

			newItem.appendChild( newLink );
			navParentSubmenu.appendChild( newItem );

			navParentItem.classList.add( 'js-active' );
			newItem.classList.add( 'js-clone' );
			document.body.classList.add( 'js-nav-back' );

			if ( megamenu ) {

				megamenu.style.maxHeight = `${ megamenuHeight() }px`;
				navParentItem.querySelector( '.sub-menu' ).style.height = `${ megamenu.scrollHeight }px`;
				megamenu.scrollTop = 0;

			}

		}

	} );

} );

/**
 * Mobile menu back
 */
const navMobileBack = document.querySelector( '.page-header__menu__back' );
navMobileBack.addEventListener( 'click', () => {

	document.body.classList.remove( 'js-nav-back' );

	const clonedItem = document.querySelector( '.js-clone' );
	clonedItem.remove();

	navParentItems.forEach( ( navParentItem ) => {

		navParentItem.classList.remove( 'js-active' );

	} );

	if ( megamenu ) {

		megamenu.scrollTop = 0;

	}

} );

/**
 * Search trigger
 */
const searchTrigger = document.querySelector( '.js-search-trigger' );
searchTrigger.addEventListener( 'click', () => {

	const searchForms = document.querySelectorAll( '.search-form' );
	const searchPromptsContainers = document.querySelectorAll( '.search-form__prompts' );
	const body = document.querySelector( 'body' );
	const searchWindow = document.querySelector( '.search-window .search-window__content' );

	searchForms.forEach( ( searchForm ) => {

		searchForm.classList.remove( 'js-active' );

	} );

	searchPromptsContainers.forEach( ( searchPromptsContainer ) => {

		searchPromptsContainer.innerHTML = '';

	} );

	document.body.classList.toggle( 'js-search-open' );
	document.body.classList.remove( 'js-nav-open' );

	if ( searchWindow ) {

		if ( body.classList.contains( 'js-search-open' ) ) {

			const searchWindowHeight = window.innerHeight - Math.ceil( searchWindow.getBoundingClientRect().top );
			searchWindow.style.maxHeight = `${ searchWindowHeight }px`;

		} else {

			searchWindow.style.maxHeight = '';

		}

	}

} );

/**
 * Display search prompts
 */
let timer;
const searchInputs = document.querySelectorAll( '.search-form__input' );
searchInputs.forEach( ( searchInput ) => {

	searchInput.addEventListener( 'input', ( e ) => {

		const searchForm = e.target.closest( '.search-form' );
		const key = e.target.value;
		const debounceGetSearchPrompt = debounce( getSearchPrompt, 250 );

		clearTimeout( timer );
		timer = setTimeout( () => {

			debounceGetSearchPrompt( key, searchForm );

		}, 500 );

	} );

} );

/**
 * Hide Search prompts
 */
document.body.addEventListener( 'click', ( e ) => {

	const target = e.target;

	if ( ! target.classList.contains( 'search-form' ) && ! ! target.classList.contains( 'search-form__input' ) ) {

		const searchForms = document.querySelectorAll( '.search-form' );
		const searchPromptsContainers = document.querySelectorAll( '.search-form__prompts' );

		searchForms.forEach( ( searchForm ) => {

			searchForm.classList.remove( 'js-active' );

		} );

		searchPromptsContainers.forEach( ( searchPromptsContainer ) => {

			searchPromptsContainer.innerHTML = '';

		} );

	}

} );

/**
 * Gets Search prompt
 * Performs AJAX request
 *
 * @param {string} key
 * @param {Element} searchForm
 */
const getSearchPrompt = ( key, searchForm ) => {

	const searchPromptsContainer = searchForm.querySelector( '.search-form__prompts' );

	searchPromptsContainer.innerHTML = '';

	if ( key.length > 0 ) {

		searchForm.classList.add( 'js-active' );

		const body = new FormData();
		body.append( 'action', 'get_search_prompts' );
		body.append( 'nonce', wombatAjax.nonce );
		body.append( 'key', key );

		fetch( wombatAjax.url, {
			method: 'POST',
			credentials: 'same-origin',
			body: body,
		} )
			.then( ( response ) => response.json() )
			.then( ( data ) => {

				if ( Array.isArray( data.data ) && data.data.length > 0 ) {

					let li, a;

					data.data.forEach( ( prompt ) => {

						if ( typeof prompt === 'string' ) {

							prompt = JSON.parse( prompt );

						}

						a = document.createElement( 'a' );
						li = document.createElement( 'li' );
						a.setAttribute( 'href', prompt.link )
						a.textContent = prompt.title;
						li.appendChild( a );
						searchPromptsContainer.appendChild( li );

					} );

				}

			} )
			.catch( ( error ) => {

				// eslint-disable-next-line no-console
				console.error( 'Error:', error );

			} );

	} else {

		searchForm.classList.remove( 'js-active' );

	}

};

/**
 * Debounce
 *
 * @param {function} callback
 * @param {integer} delay
 * @return {(function(...[*]): void)|*}
 */
function debounce( callback, delay ) {

	let timeoutId;
	/* eslint-disable func-names */
	return function( ...args ) {

		clearTimeout( timeoutId );
		timeoutId = setTimeout( () => {

			callback.apply( this, args );

		}, delay );

	};

}
